
import { Component } from 'vue-property-decorator';
import BaseForm from '../Common/Mixins/BaseForm.vue';
import { mixins } from 'vue-class-component';
import { FormField, Network, NetworkDataLoaderParams } from '@/types';
import { networkSvc } from '@/services';

@Component({
  name: 'network-form'
})
export default class NetworkForm extends mixins(BaseForm) {
  fields: FormField[] = [
    {
      type: 'input',
      subType: 'text',
      data: '',
      key: 'network_name',
      label: 'Network Name',
      description: 'The name of the network',
      required: true,
      placeholder: 'Please enter the network name.'
    },
    {
      type: 'input',
      subType: 'text',
      data: '',
      key: 'acronym',
      label: 'Acronym',
      description: 'The acronym of the network',
      required: true,
      placeholder: 'Please enter the network acronym.'
    },
    {
      type: 'options',
      label: 'Options',
      key: 'network_options',
      options: [
        {
          data: false,
          key: 'cookie_stuff',
          label: 'Cookie Stuff'
        }
      ]
    },
    {
      type: 'select',
      data: 'active',
      options: ['active', 'inactive'],
      key: 'affiliate_network_status',
      label: 'Status',
      required: true
    },
    {
      type: 'select',
      data: 'active',
      options: ['CA', 'UK', 'AU', 'US', 'ALL'],
      key: 'country_code',
      label: 'Country Code',
      required: false
    },
    {
      type: 'input',
      subType: 'url',
      data: '',
      key: 'login_url',
      label: 'Login URL',
      required: true
    },
    {
      type: 'select',
      data: '',
      options: [],
      key: 'network_account_id',
      label: 'Network Account',
      required: false
    },
    {
      type: 'select',
      data: 'active',
      options: [
        {
          value: true,
          text: 'Yes'
        },
        {
          value: false,
          text: 'No'
        }
      ],
      key: 'is_autoconfigured',
      label: 'Autoconfigured',
      required: true
    }
  ];

  protected deleteRedirectRoute: any = { name: 'networks' };
  protected deleteSuccessMsg: string = 'Network deleted.';
  protected successMsg = this.isCreateForm
    ? 'New Network Created.'
    : 'Network Updated.';

  get deleteBtnText() {
    return this.isCreateForm ? '' : 'Delete Network';
  }

  async mounted() {
    this.fetchNetworkAccountOption();
  }

  async fetchNetworkAccountOption() {
    const networkAccountOptions = await networkSvc.getNetworkAccountOptions();
    this.fields[6].options = networkAccountOptions.map(networkAccount => ({
      value: networkAccount.id,
      text: networkAccount.network_name
    }));
    this.fields[6].options!.push({
      value: '',
      text: ''
    });
  }

  async submitForm(data: Network): Promise<any> {
    const network: Network = await networkSvc.mutateNetwork({
      ...data,
      id: this.modelId
    });
    return network;
  }

  async loadFormData(id: number): Promise<any> {
    const network = await networkSvc.getNetwork({
      filters: { networkId: id }
    } as NetworkDataLoaderParams);
    this.$emit('networkLoad', network);
    return network;
  }

  async deleteForm(): Promise<any> {
    return networkSvc.deleteNetwork(this.modelId);
  }

  onSubmitted(network: Network) {
    if (network) {
      this.$notify.success(
        this.isCreateForm ? 'New Network Created.' : 'Network Updated.'
      );
      this.modelId = network.id as number;
      this.isCreateForm = false;
      this.$emit('networkSaved', network);
    }
  }
}
